import { render, staticRenderFns } from "./GuideNavigation.vue?vue&type=template&id=38e2f53a&"
import script from "./GuideNavigation.vue?vue&type=script&lang=js&"
export * from "./GuideNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports